module.exports = {
    SEE_FULL_COMPANY_DATA:'aas:cobranza.see_company_full_info'
}